import { render, staticRenderFns } from "./ViewBtn.vue?vue&type=template&id=6372b595&"
import script from "./ViewBtn.vue?vue&type=script&lang=js&"
export * from "./ViewBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports